import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "description-popover",
  templateUrl: "./description-popover.component.html",
  styleUrls: ['./description-popover.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DescriptionPopoverComponent {

  @Input() public readonly = false;
  @Input() public description: string;
  @Input() public interactive = false;

  @Input() public position: string = "right";
  @Input() public trigger: string = 'click';

  public documentBody = () => document.body;

}
